import { render, staticRenderFns } from "./List-Order-Detail.vue?vue&type=template&id=3777ca6e&scoped=true"
import script from "./List-Order-Detail.vue?vue&type=script&lang=js"
export * from "./List-Order-Detail.vue?vue&type=script&lang=js"
import style0 from "./List-Order-Detail.vue?vue&type=style&index=0&id=3777ca6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3777ca6e",
  null
  
)

export default component.exports